import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Typo } from 'uikit/content';

import styles from '../styles/uikitLabelsLabel.module.scss';

const Label = ({
  text,
  type = 'default',
  variant = 's01',
  modifier = '',
  className = '',
  testId = '',
}) => {
  const CLASSES = {
    type: {
      default: styles.isTypeDefault,
      live: styles.isTypeLive,
      success: styles.isTypeSuccess,
      warning: styles.isTypeWarning,
    },
  };

  const TYPO_COLORS = {
    default: undefined,
    live: 'white',
    success: 'positive',
    warning: 'negative',
  };

  return (
    <div
      className={classnames(styles.element, { [CLASSES.type[type]]: type }, className)}
      data-testid={testId}
    >
      {type === 'live' && <span className={styles.iconLiveNow} aria-hidden />}
      <Typo
        element="span"
        variant={variant}
        modifier={type === 'live' ? 'uppercase' : modifier}
        weight={type !== 'live' ? 'medium' : undefined}
        color={TYPO_COLORS[type]}
      >
        {text}
      </Typo>
    </div>
  );
};

Label.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['default', 'live', 'success', 'warning']),
  variant: PropTypes.string,
  modifier: PropTypes.string,
  className: PropTypes.string,
  testId: PropTypes.string,
};

export { Label as LabelStorybook };
export default memo(Label);
